import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import { temAlgumaPermissao } from '../utils/permissoes'
import VueTheMask from 'vue-the-mask'
import money from 'vuejs-money'

Vue.use(VueRouter)
Vue.use(VueTheMask)
Vue.use(money)

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/cte',
            name: 'CTE',
            component: () => import('../views/Dashboard.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/mdfe',
            name: 'MDFE',
            component: () => import('../views/DashboardMDFE.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR']
            }
        },
        {
            //
            // MDF-e de distribuicao: remonta a perna final a partir do que
            // chegou ao CD. MODERADOR e ADMIN so - mesma regra da
            // wi-cadastro-api, que responde 403 para os demais perfis. A
            // rotina vai emitir documento fiscal e disparar CIOT nas
            // proximas fatias.
            //
            path: '/mdfe-distribuicao',
            name: 'MdfeDistribuicao',
            component: () => import('../views/MdfeDistribuicao.vue'),
            meta: {
                roles: ['ROLE_MODERADOR', 'ROLE_ADMIN']
            }
        },
        {
            //
            // Os perfis sao os que a wi-nfse-api aceita (ADMIN, MODERADOR,
            // USUARIO). O item de menu so e gerado quando o build tem a URL
            // da API - ver config.js.
            //
            path: '/relatorio-nfse',
            name: 'RelatorioNfse',
            component: () => import('../views/RelatorioNfse.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            path: '/export',
            name: 'Exportar',
            component: () => import('../views/Exportar.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/xlsx',
            name: 'Xlsx',
            component: () => import('../views/ExportarCsv.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/receber',
            name: 'Receber',
            component: () => import('../views/DashboardReceber.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/',
            name: 'Monitor',
            component: () => import('../views/Home.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/mdfee',
            name: 'MDFEE',
            component: () => import('../views/DashboardMotorista.vue'),
            meta: {
                roles: ['ROLE_MOTORISTA', 'ROLE_USUARIO_MDFE_ENCERRAMENTO', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/login',
            name: 'Login',
            component: () => import('../views/Login.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MOTORISTA', 'ROLE_USUARIO_MDFE_ENCERRAMENTO', 'ROLE_MODERADOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/portal',
            name: 'Home',
            component: () => import('../views/Home.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MOTORISTA', 'ROLE_USUARIO_MDFE_ENCERRAMENTO', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/tranportador',
            name: 'Tranportador',
            component: () => import('../views/CadastroTransportador.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            // Proposta de tela nova, convivendo com a atual para comparacao.
            // Traz a lista, o filtro e o cadastro de Socios; as demais acoes
            // continuam na tela atual ate serem migradas uma a uma.
            path: '/tranportador-novo',
            name: 'TranportadorNovo',
            component: () => import('../views/CadastroTransportadorNovo.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            // Cadastro de um transportador novo. Path proprio, e nao
            // /tranportador-novo/cadastrar, pra nao depender da ordem de
            // declaracao contra a rota com :id.
            path: '/tranportador-cadastrar',
            name: 'TransportadorCadastrar',
            component: () => import('../views/TransportadorDetalhe.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            // Pagina do transportador: identificacao fixa no topo e sub-abas
            // para cada assunto. Rota com id para que o link possa ser
            // compartilhado e o voltar do navegador funcione - ao contrario
            // dos nove modais da tela atual.
            path: '/tranportador-novo/:id',
            name: 'TransportadorDetalhe',
            component: () => import('../views/TransportadorDetalhe.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            // Configuracao de integracao CIOT (EXTRATTA / REPOM / VELOE) por participante.
            // So ROLE_ADMIN e ROLE_MODERADOR - dado sensivel (token, login, senha).
            path: '/habilitar-integracao-ciot',
            name: 'HabilitarIntegracaoCiot',
            component: () => import('../views/HabilitarIntegracaoCiot.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            // Cancelamento avulso de CT-e via API da SEFAZ. Acao irreversivel,
            // por isso restrita a ROLE_ADMIN e ROLE_MODERADOR.
            path: '/cancelar-cte',
            name: 'CancelarCte',
            component: () => import('../views/CancelarCte.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            // Rotina "Log de Cadastros" - auditoria de criacao/alteracao em
            // Veiculo/Motorista/CIOT. Restrita a ROLE_ADMIN/ROLE_MODERADOR.
            path: '/log-cadastros',
            name: 'LogCadastros',
            component: () => import('../views/LogCadastros.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            // Consulta a averbacao de um CT-e por chave (situacao, dados da
            // seguradora, tentativas do worker). So leitura - sem efeito
            // colateral. Endpoint no BFF cte-app-web-api (PR #63).
            // Restrita a ROLE_ADMIN/ROLE_MODERADOR - mesmo grupo do Cancelar
            // CT-e e Log de Cadastros.
            // Aceita ?chave=<44> pra deep link (mounted consulta ao abrir).
            path: '/averbacao-cte',
            name: 'AverbacaoCte',
            component: () => import('../views/AverbacaoCte.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            // Reenvio de averbacao em lote: lista os CT-e autorizados de um
            // filtro e reenvia os selecionados de uma vez. Mesma permissao
            // do reenvio unitario no Relatorio CT-e.
            path: '/averbacao-cte-lote',
            name: 'AverbacaoCteLote',
            component: () => import('../views/AverbacaoCteLote.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            // Relatorio dos eventos de MDF-e sem averbacao na AT&M (BFF #65)
            // com reprocessamento unitario na engine MDF-e (#20). Os dois
            // endpoints exigem ADMIN/MODERADOR.
            path: '/averbacao-mdfe',
            name: 'AverbacaoMdfe',
            component: () => import('../views/AverbacaoMdfe.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            // Rotina de suporte: gera um MDF-e novo a partir de um encerrado
            // ou cancelado por engano. Emite documento fiscal - a API exige
            // as mesmas roles.
            path: '/reemissao-mdfe',
            name: 'ReemissaoMdfe',
            component: () => import('../views/ReemissaoMdfe.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            path: '/atualiza-certificado',
            name: 'AtualizaCertificado',
            component: () => import('../views/AtualizaCertificado.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR', 'ROLE_USUARIO']
            }
        },
        {
            path: '/emissao-viagem',
            name: 'EmissaoViagem',
            component: () => import('../views/EmissaoViagem.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR']
            }
        },
        {
            path: '/painel-entregas',
            name: 'PainelEntregas',
            component: () => import('../views/PainelEntregas.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/monitor-entregas',
            name: 'MonitorEntregas',
            component: () => import('../views/MonitorEntregas.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/monitor-entregas/:id/detalhe',
            name: 'DetalheEntrega',
            component: () => import('../views/DetalheEntrega.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/ciot',
            name: 'ListaCiot',
            component: () => import('../views/ListaCiot.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/ciot/novo',
            name: 'CiotNovo',
            component: () => import('../views/CiotCadastro.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/ciot/:id/editar',
            name: 'CiotEditar',
            component: () => import('../views/CiotCadastro.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            // Emissao CIOT avulso - rotina nova independente da Emissao Viagem.
            // Restrito a ADMIN/MODERADOR (operacao sensivel - gera CIOT pra
            // ANTT). Front chama wi-ciot-api direto via httpCiot.
            path: '/ciot-avulso/emissao',
            name: 'CiotAvulsoEmissao',
            component: () => import('../views/CiotAvulsoEmissao.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            // Relatorio dos envios CIOT (le ciot.operacao_ciot_log via
            // cte-app-web-api). Mesmas roles da emissao.
            path: '/ciot-avulso/relatorio',
            name: 'CiotAvulsoRelatorio',
            component: () => import('../views/CiotAvulsoRelatorio.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            path: '/calculadora-piso-frete',
            name: 'CalculadoraPisoFrete',
            component: () => import('../views/CalculadoraPisoFrete.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/cadastro-veiculo',
            name: 'CadastroVeiculo',
            component: () => import('../views/CadastroVeiculo.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/relatorio-produtividade',
            name: 'RelatorioProdutividade',
            component: () => import('../views/RelatorioProdutividade.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_MODERADOR', 'ROLE_ADMIN', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/contrato',
            name: 'Contratos',
            component: () => import('../views/GeracaoContratos.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            path: '/rotina-adm',
            name: 'Rotina-adm',
            component: () => import('../views/RotinasAdministrativas.vue'),
            meta: {
                roles: ['ROLE_MODERADOR', 'ROLE_ADMIN']
            }
        },
        {
            // Agrupador de rotas: junta cidades numa rota para a lista do
            // MDF-e de Distribuicao nao sair uma linha por cidade.
            path: '/rota-agrupador',
            name: 'RotaAgrupador',
            component: () => import('../views/RotaAgrupador.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO']
            }
        },
        {
            // Caminho proprio para a rota nova, antes da rota com :id,
            // pra nao depender da ordem de declaracao - mesmo motivo de
            // /tranportador-cadastrar.
            path: '/rota-agrupador/nova',
            name: 'RotaAgrupadorNova',
            component: () => import('../views/RotaAgrupadorFicha.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO']
            }
        },
        {
            // Ficha da rota: identificacao no topo e acoes no rodape. O
            // transportador vai na query porque a API filtra por ele em
            // toda chamada, e assim o link reaberto continua valendo.
            path: '/rota-agrupador/:id',
            name: 'RotaAgrupadorFicha',
            component: () => import('../views/RotaAgrupadorFicha.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO']
            }
        },
        {
            path: '/relatorio-viagens',
            name: 'RelatorioViagens',
            component: () => import('../views/RelatorioViagens.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/relatorio-erros-mdfe',
            name: 'RelatorioErrosMdfe',
            component: () => import('../views/RelatorioErrosMdfe.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/tributacao',
            name: 'Tributacao',
            component: () => import('../views/Tributacao.vue'),
            meta: {
                roles: ['ROLE_CONTADOR', 'ROLE_MODERADOR', 'ROLE_ADMIN']
            }
        },
        {
            // Proposta de tela nova, convivendo com a atual para comparacao.
            path: '/tributacao-nova',
            name: 'TributacaoNova',
            component: () => import('../views/TributacaoNova.vue'),
            meta: {
                roles: ['ROLE_CONTADOR', 'ROLE_MODERADOR', 'ROLE_ADMIN']
            }
        },
        {
            path: '/nfse-configuracao',
            name: 'NfseConfiguracao',
            component: () => import('../views/NfseConfiguracao.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        },
        {
            path: '/certificados-digitais',
            name: 'CertificadosDigitais',
            component: () => import('../views/CertificadosDigitais.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/impostos-ibs-cbs',
            name: 'ImpostosIbsCbs',
            component: () => import('../views/ImpostosIbsCbs.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR', 'ROLE_MOTORISTA']
            }
        },
        {
            path: '/faturas',
            name: 'Faturas',
            component: () => import('../views/Faturas.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/controlecontratos',
            name: 'ControleContratos',
            component: () => import('../views/ControleContratos.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }},
        // Rota de Em Construção
        {
            path: '/em-construcao',
            name: 'EmConstrucao',
            component: () => import('../views/EmConstrucao.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_USUARIO_OPERADOR', 'ROLE_CONTADOR', 'ROLE_MOTORISTA', 'ROLE_USUARIO_MDFE_ENCERRAMENTO']
            }
        },
        // Rotas de Motoristas (liberadas para todos os perfis com acesso)
        {
            path: '/cadastro-motorista',
            name: 'ListaMotoristas',
            component: () => import('../views/ListaMotoristas.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/cadastro-motorista/novo',
            name: 'NovoMotorista',
            component: () => import('../views/CadastroMotorista.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/cadastro-motorista/:id/editar',
            name: 'EditarMotorista',
            component: () => import('../views/CadastroMotorista.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/cadastro-motorista/:id/visualizar',
            name: 'VisualizarMotorista',
            component: () => import('../views/CadastroMotorista.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        // Rotas de Veículos
        {
            path: '/cadastro-veiculo',
            name: 'ListaVeiculos',
            component: () => import('../views/ListaVeiculos.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/cadastro-veiculo/novo',
            name: 'NovoVeiculo',
            component: () => import('../views/CadastroVeiculo.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/cadastro-veiculo/:id',
            name: 'EditarVeiculo',
            component: () => import('../views/CadastroVeiculo.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        {
            path: '/cadastro-veiculo/:id/visualizar',
            name: 'VisualizarVeiculo',
            component: () => import('../views/CadastroVeiculo.vue'),
            meta: {
                roles: ['ROLE_USUARIO', 'ROLE_ADMIN', 'ROLE_MODERADOR', 'ROLE_USUARIO_MONITOR', 'ROLE_CONTADOR']
            }
        },
        // Importacao ANTT RNTRC
        {
            path: '/importacao-antt-rntrc',
            name: 'ImportacaoAnttRntrc',
            component: () => import('../views/ImportacaoAnttRntrc.vue'),
            meta: {
                roles: ['ROLE_ADMIN', 'ROLE_MODERADOR']
            }
        }

    ]
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = store.state.user.isLoggedIn
    const permissoes = store.state.user.permissoes
    const userLogin = localStorage.getItem('userLogin')
    const restrictedDeliveryRoutes = ['PainelEntregas', 'MonitorEntregas', 'DetalheEntrega']

    const isAllowedDeliveryUser = () => {
        const allowedId = '687'
        const allowedUserLogin = 'fatura100'

        const storedLogin = localStorage.getItem('userLogin')
        const storedId = localStorage.getItem('idUsuario') || localStorage.getItem('id')

        let cachedUserDataId = null
        try {
            const cachedUserData = localStorage.getItem('userData')
            if (cachedUserData) {
                const parsed = JSON.parse(cachedUserData)
                cachedUserDataId = parsed && parsed.id != null ? String(parsed.id) : null
            }
        } catch (e) {
            cachedUserDataId = null
        }

        return storedLogin === allowedUserLogin || String(storedId) === allowedId || cachedUserDataId === allowedId
    }
    
    console.log('Router Guard - UserLogin:', userLogin, 'Permissoes:', permissoes, 'Rota:', to.name)
    
    if (to.name !== 'Login' && !isAuthenticated) {
        next({ name: 'Login' })
    } else if (!isAuthenticated) {
        next()
    } else {
        const hasPermission = to.matched.some(route =>
            temAlgumaPermissao(permissoes, route.meta.roles)
        )
        
        // Verifica se a rota requer permissão específica (cadastros)
        const requiresSpecificRole = to.matched.some(route => route.meta.requiresSpecificRole)
        
        console.log('HasPermission:', hasPermission, 'RequiresSpecificRole:', requiresSpecificRole)
        
        // Rotas de entregas: só o usuário específico pode visualizar
        if (restrictedDeliveryRoutes.includes(to.name)) {
            if (hasPermission && isAllowedDeliveryUser()) {
                next()
            } else if (to.name !== 'EmConstrucao') {
                next({ name: 'EmConstrucao' })
            } else {
                next()
            }
            return
        }
        // Para rotas de cadastro, verifica se é o usuário específico
        if (requiresSpecificRole) {
            if (userLogin === 'fatura100' && hasPermission) {
                console.log('Acesso liberado para fatura100')
                next()
            } else if (to.name !== 'EmConstrucao') {
                console.log('Redirecionando para Em Construção - UserLogin:', userLogin)
                next({ name: 'EmConstrucao' })
            } else {
                next()
            }
        } else if (hasPermission) {
            next()
        } else {
            // Redireciona para login para outras rotas sem permissão
            next({ name: 'Login' })
        }
    }
})

export default router;